import { Component, ReactNode } from "react";
import styled from "styled-components";
import { theme } from "../../utility";
import { SecondaryBtn } from "../ButtonComponents";

const StyledNavbar = styled.nav<{ theme: typeof theme }>`
  width: 90%;
  background-color: none;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  padding: 10px;
  align-items:center;
`;

const ContainerLogo = styled.div`
  align-items:center;
`;

class Logo extends Component {
  render(): ReactNode {
    return (
      <svg
        width="90"
        height="34"
        viewBox="0 0 97 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M67.2747 25V19.656L69.1947 17.544L73.6427 25H79.0827L72.7787 14.568L79.1147 7.528H73.1947L67.2747 13.832V0.776001H62.4747V25H67.2747ZM43.5555 24.2C42.1475 24.9893 40.5795 25.384 38.8515 25.384C37.1235 25.384 35.5502 24.9893 34.1315 24.2C32.7129 23.4107 31.5822 22.328 30.7395 20.952C29.8969 19.576 29.4755 18.0133 29.4755 16.264C29.4755 14.4933 29.8969 12.9253 30.7395 11.56C31.5822 10.1947 32.7129 9.11733 34.1315 8.328C35.5502 7.53867 37.1235 7.144 38.8515 7.144C40.5795 7.144 42.1475 7.53867 43.5555 8.328C44.9635 9.11733 46.0889 10.1947 46.9315 11.56C47.7742 12.9253 48.1955 14.4933 48.1955 16.264C48.1955 18.0133 47.7742 19.576 46.9315 20.952C46.0889 22.328 44.9635 23.4107 43.5555 24.2ZM14.592 13.8L10.528 25H6.36799L0.35199 7.528H5.31199L8.70399 17.672L12.512 7.528H16.672L20.448 17.672L23.84 7.528H28.832L22.784 25H18.624L14.592 13.8ZM38.8515 21.064C37.5502 21.064 36.4889 20.616 35.6675 19.72C34.8462 18.824 34.4355 17.672 34.4355 16.264C34.4355 14.8773 34.8462 13.7307 35.6675 12.824C36.4889 11.9173 37.5502 11.464 38.8515 11.464C40.1529 11.464 41.2089 11.9173 42.0195 12.824C42.8302 13.7307 43.2355 14.8773 43.2355 16.264C43.2355 17.672 42.8302 18.824 42.0195 19.72C41.2089 20.616 40.1529 21.064 38.8515 21.064ZM55.3671 15.592V25H50.5671V7.528H55.0471V10.152C55.4951 9.064 56.1298 8.32267 56.9511 7.928C57.7724 7.53333 58.7164 7.336 59.7831 7.336H60.8071V11.496H59.3031C58.1298 11.496 57.1804 11.8533 56.4551 12.568C55.7298 13.2827 55.3671 14.2907 55.3671 15.592ZM83.5982 1.16V4.68H81.6782V1.16H83.5982ZM83.5982 25V8.008H81.6782V25H83.5982ZM95.3138 25.16C95.0151 25.1813 94.7804 25.192 94.6098 25.192C93.1804 25.192 92.0871 24.792 91.3298 23.992C90.5724 23.192 90.1938 22.024 90.1938 20.488V9.832H86.9938V8.008H88.2098C88.8284 8.008 89.3138 7.816 89.6658 7.432C90.0178 7.048 90.1938 6.52533 90.1938 5.864V4.04H92.1138V8.008H95.8258V9.832H92.1138V20.488C92.1138 20.9573 92.1831 21.416 92.3218 21.864C92.4604 22.312 92.7324 22.6747 93.1378 22.952C93.5431 23.2293 94.1298 23.368 94.8978 23.368C95.0684 23.368 95.2764 23.3573 95.5218 23.336C95.7671 23.3147 95.9644 23.2933 96.1138 23.272V25.032C95.8791 25.096 95.6124 25.1387 95.3138 25.16Z"
          fill="white"
        />
      </svg>
    );
  }
}

export default class Navbar extends Component {
  render(): ReactNode {
    return (
      <StyledNavbar theme={theme}>
        <ContainerLogo>
          <Logo />
        </ContainerLogo>
        <SecondaryBtn message="Apply for access" />
      </StyledNavbar>
    );
  }
}
